export default function OverviewCardShell({ title, isLoading, error, good, children }) {
  const borderClass = error
    ? 'border-red-300'
    : good === false
    ? 'border-amber-300'
    : good === true
    ? 'border-green-300'
    : 'border-cyan-100';

  return (
    <div className={`rounded-2xl border-2 bg-white p-5 ${borderClass}`}>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        {!isLoading && !error && good !== undefined && (
          <span className={good ? 'text-lg text-green-600' : 'text-lg text-amber-600'}>
            {good ? '✅' : '⚠️'}
          </span>
        )}
      </div>

      {isLoading ? (
        <p className="text-sm text-slate-500">Đang kiểm tra...</p>
      ) : error ? (
        <p className="text-sm text-red-600">{error}</p>
      ) : (
        children
      )}
    </div>
  );
}
